import React from "react";
import { Box, Typography } from "@mui/material";
import { FN } from "./facilityNetworkTheme";

type MetaItem = {
  label: string;
  value: string;
};

type Props = {
  sectionLabel: string;
  facilityName: string;
  metaItems: MetaItem[];
  /** Figma unlink card uses error surface; link card uses white. */
  tone?: "default" | "error";
};

/** Figma 9128:96274 / 9131:97598 — facility summary in review dialogs */
export default function RequestDialogFacilityCard({
  sectionLabel,
  facilityName,
  metaItems,
  tone = "default",
}: Props) {
  const isError = tone === "error";
  return (
    <Box
      sx={{
        bgcolor: isError ? "#fde7e9" : "#fff",
        border: `1px solid ${isError ? "#e7a3a7" : "#e5e5e5"}`,
        borderRadius: "4px",
        px: isError ? 2 : "22px",
        py: isError ? 2 : 3,
        boxShadow: "1px 1px 2px rgba(98,102,104,0.05), -1px -1px 2px rgba(98,102,104,0.05)",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <Typography
        sx={{
          fontFamily: FN.fontFamily,
          fontSize: 14,
          fontWeight: 600,
          color: FN.figmaAccent,
          lineHeight: "20px",
          mb: 0.5,
        }}
      >
        {sectionLabel}
      </Typography>
      <Typography
        sx={{
          fontFamily: FN.fontFamily,
          fontSize: 16,
          fontWeight: 600,
          color: FN.figmaNeutral,
          lineHeight: "22px",
          mb: 0.5,
          wordBreak: "break-word",
        }}
      >
        {facilityName}
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center" }}>
        {metaItems.map((item) => (
          <Box key={item.label} sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
            <Typography
              sx={{
                fontFamily: FN.fontFamily,
                fontSize: 12,
                color: FN.figmaNeutral,
                letterSpacing: "0.03px",
                lineHeight: "16px",
              }}
            >
              {item.label}
            </Typography>
            <Typography
              sx={{
                fontFamily: FN.fontFamily,
                fontSize: 12,
                color: FN.figmaAccent,
                letterSpacing: "0.03px",
                lineHeight: "16px",
              }}
            >
              {item.value}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
